import { ProductRepeaterForm } from "./ProductRepeaterForm";
import { useMachineForm } from "../core/MachineProvider";
import { KTIcon } from "../../../_metronic/helpers";

export const MachineForm = ({ formik }) => {

  const { navigate, loading } = useMachineForm()

  const addProduct = () => {
    formik.setFieldValue('products', [...formik.values.products, { product: '', sessionTime: '' }])
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            <h3 className='fw-bold mb-1'>Dados da máquina</h3>
          </div>
        </div>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span className='required'>Nome</span>
            </label>
            <div className='col-lg-8 fv-row'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Nome da máquina'
                {...formik.getFieldProps('name')}
              />
              {formik.touched.name && formik.errors.name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors?.name}</div>
                </div>
              )}
            </div>
          </div>
          <div className='row'>
            <label className='col-lg-4 col-form-label fw-bold fs-6'>
              <span>Observação</span>
            </label>

            <div className='col-lg-8 fv-row'>
              <input
                id="description"
                type='text'
                className='form-control form-control-lg form-control-solid'
                placeholder='Observação'
                {...formik.getFieldProps('description')}
              />
              {formik.touched.description && formik.errors.description ? (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors?.description}</div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-6'>
          <div className='card-title flex-column'>
            <h3 className='fw-bold mb-1'>Produtos</h3>
            <span className='text-muted fs-7'>
              Produtos executados pela máquina e o tempo de sessão de cada um. No agendamento com
              máquina, a duração vem deste tempo.
            </span>
          </div>
          <div className='card-toolbar'>
            <button type='button' className='btn btn-light-danger' onClick={addProduct}>
              <KTIcon iconName='plus' className='fs-2' />
              Adicionar Produto
            </button>
          </div>
        </div>

        <div className='card-body py-4'>
          <ProductRepeaterForm formik={formik} />
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button type="button" className="btn btn-secondary me-2" onClick={() => navigate(-1)}>Cancelar</button>

          <button type='submit' className='btn btn-danger' disabled={loading || !formik.isValid}>
            {!loading && 'Salvar'}
            {loading && (
              <span className='indicator-progress' style={{ display: 'block' }}>
                Salvando...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </form>
  );
};
